import { memo, useEffect, useState } from "react";

import { Controller } from "react-hook-form";

import { AuthApiClient } from "../../../../../../../../common/api/AuthApiClient";
import StatusToggle from "../../../../../../../../common/components/item/StatusToggle";
import { IAlertFormBase } from "../AlertForm";
import AlertToggleSection from "./AlertToggleSection";

interface EmailAlertToggleSectionProps extends IAlertFormBase {
  everySwithcIsOff: boolean;
}

const EmailAlertToggleSectionComponent = ({
  formValues,
  control,
  everySwithcIsOff,
}: EmailAlertToggleSectionProps) => {
  const [userEmail, setUserEmail] = useState<string>("");

  useEffect(() => {
    const authClient = new AuthApiClient();

    authClient.getCurentUser().then(userInfo => {
      setUserEmail(userInfo.email);
    });
  }, []);

  return (
    <AlertToggleSection
      toggleChecked={formValues.isEmailToggleEnabled}
      title={`Email (${userEmail})`}
      hasError={everySwithcIsOff}
      ToggleComponent={
        <Controller
          name="isEmailToggleEnabled"
          control={control}
          render={({ field }) => (
            <StatusToggle
              {...field}
              checked={field.value}
              handleChange={field.onChange}
            />
          )}
        />
      }
    />
  );
};

const EmailAlertToggleSection = memo(EmailAlertToggleSectionComponent);

export default EmailAlertToggleSection;
